import POIStep from "@/components/POI/POIStep/POIStep.vue";
import POIHutsStateFields from "@/components/POI/POIStateFields/POIHutsStateFields/POIHutsStateFields.vue";

export default {
  components: { POIStep, POIHutsStateFields },
  props: ["step", "position", "editedItem", "isOwnedBySubPrincipal"],
  methods: {
    changeStep(position) {
      this.$emit("changeStep", position);
    }
  }
};
